import React from "react";
import { useTranslation } from "react-i18next";

export default function TableWidget({ title, columns, data }) {
  const { t } = useTranslation();
  const defaultColumns = [
    { key: "timestamp", label: t("home.grid.col.time") },
    { key: "metric", label: t("home.grid.col.metric") },
    { key: "value", label: t("home.grid.col.value") },
    { key: "status", label: t("home.grid.col.status") },
  ];

  const defaultData = [
    { timestamp: "12:45:30", metric: "Temperature", value: "54.8 °C", status: "Normal" },
    { timestamp: "12:45:25", metric: "Vibration", value: "25.5 mm/s", status: "Normal" },
    { timestamp: "12:45:20", metric: "Pressure", value: "104 kPa", status: "Warning" },
    { timestamp: "12:45:15", metric: "Voltage", value: "223 V", status: "Normal" },
    { timestamp: "12:45:10", metric: "Current", value: "11.8 A", status: "Normal" },
  ];

  const cols = columns || defaultColumns;
  const rows = data || defaultData;

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "normal":
      case "ok":
        return "#4caf50";
      case "warning":
        return "#ff9800";
      case "error":
      case "critical":
        return "#f44336";
      default:
        return "var(--text-secondary)";
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <span style={styles.title}>{title}</span>
      </div>
      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              {cols.map((col) => (
                <th key={col.key} style={styles.th}>
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={idx} style={styles.tr}>
                {cols.map((col) => (
                  <td
                    key={col.key}
                    style={{
                      ...styles.td,
                      color: col.key === "status" ? getStatusColor(row[col.key]) : "var(--text-primary)",
                    }}
                  >
                    {row[col.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const styles = {
  container: {
    backgroundColor: "var(--bg-card)",
    borderRadius: "2px",
    padding: "8px 10px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    marginBottom: "4px",
  },
  title: {
    color: "var(--text-primary)",
    fontSize: "12px",
    fontWeight: "500",
  },
  tableWrapper: {
    flex: 1,
    overflow: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "11px",
  },
  th: {
    textAlign: "left",
    padding: "4px 8px",
    color: "var(--text-secondary)",
    fontWeight: "500",
    borderBottom: "1px solid var(--border)",
    whiteSpace: "nowrap",
  },
  tr: {
    borderBottom: "1px solid var(--border)",
  },
  td: {
    padding: "4px 8px",
    color: "var(--text-primary)",
    whiteSpace: "nowrap",
  },
};
